module.exports = __webpack_public_path__ + "img/kneecircumference.5b5de417.jpeg";